import Vue from 'vue';

/**
 * Font Awesome Setup
 * We import just the icons we need so the end bundle size is smaller.
 */
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUser, faBuilding, faSearch, faEnvelope, faPlus, faClipboard, faGavel, faPhone,
  faStethoscope, faExclamationTriangle, faCheck, faAsterisk,
} from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

/**
 * Import the rest of the app for setting up.
 */
import VeeValidate from 'vee-validate';
import VueAnalytics from 'vue-analytics';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/scss/app.scss';

/**
 * Set up the Font Awesome icons we want to use
 */
library.add(
  faUser, faBuilding, faSearch, faEnvelope, faFacebookF, faTwitter,
  faPlus, faLinkedinIn, faClipboard, faGavel, faPhone, faStethoscope,
  faExclamationTriangle, faCheck, faAsterisk,
);
Vue.component('fa', FontAwesomeIcon);

/**
 * Router middleware that handles the changing of the document title
 */
router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  return next();
});

/**
 * Set up the Vue Validation tool
 */
Vue.use(VeeValidate);

/**
 * Set up the GTag code
 */
Vue.use(VueAnalytics, {
  id: store.state.analytics_id,
  router,
});

/**
 * Instantiate Vue
 */
const app = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

/**
 * Allow only the testing suite to see the global variable set
 */
if (window.Cypress) window.app = app;
